(function () {
  window.CUDOLLA_SUPABASE_URL = 'https://zhadhjxsnmbnqdpiuiyw.supabase.co';
  window.CUDOLLA_SUPABASE_KEY = 'sb_publishable_99An6wmeGvA4fxS906_I_w_fe0t3DfM';

  function loadSupabaseLibrary(callback) {
    if (window.supabase) {
      callback();
      return;
    }

    var script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/@supabase/supabase-js@2';
    script.onload = callback;
    script.onerror = function () {
      console.error('CUDOLLA: Supabase library failed to load.');
    };

    document.head.appendChild(script);
  }

  loadSupabaseLibrary(function () {
    if (!window.CUDOLLA_SUPABASE_CLIENT) {
      window.CUDOLLA_SUPABASE_CLIENT = window.supabase.createClient(
        window.CUDOLLA_SUPABASE_URL,
        window.CUDOLLA_SUPABASE_KEY
      );

      console.log('CUDOLLA: Supabase connected.');
    }
  });
})();